export default {
    autoatendimento: 'Veus Auto-Atendimento',
    home: {
        bemvindo: 'Bem-vindo (a) ao',
        cadastrar: 'Cadastrar',
        orcamento: 'Consultar Orçamento'
    },
    cadastro: {
        title: 'Formulário de Cadastro',
        obrigatorio: 'Campo %s é obrigatório!',

        steps: {
            verificacao: 'Verificação',
            dados: 'Dados',
            dadospessoais: 'Dados Pessoais',
            endereco: 'Endereço',
            documentos: 'Documentos',
            anterior: 'Anterior',
            proximo: 'Próximo',
            enviar: 'Enviar'
        },
        unidade: 'Unidade',
        documento: 'CPF',

        nome: 'Nome completo',
        email: 'Email',
        telefone: 'Telefone',
        sexo: 'Sexo',
        masculino: 'Masculino',
        feminino: 'Feminino',
        nascimento: 'Data de Nascimento',
        //
        cep: 'CEP',
        estado: 'Estado',
        cidade: 'Cidade',
        bairro: 'Bairro',
        logradouro: 'Logradouro',
        numero: 'Número',
        complemento: 'Complemento',

        identidade: 'Identidade',
        documentos: 'Guias TISS / Pedido de Exame / Carteirinha do plano de Saúde',

        documento_invalido: 'CPF Inválido!',
        campos_invalidos: 'Campos Inválidos',
        mensagem: {
            sucesso: 'Cadastro Realizado com sucesso!',
            erro: 'Error ao realizar Cadastro!'
        }
    },
    orcamentos: {
        consultar: 'Consultar',
        meusorcamentos: 'Meus Orçamentos'
    },
    qr: {
        obrigado: 'Obrigado por utilizar o',
        explicacao: 'Utilize esse QRCode para visualizar o seu orçamento e no momento do seu atendimento',
        parafazer: 'Para realizar o seu agendamento',
        cliqueaqui: 'Clique Aqui',
        faleconosco: 'ou fale conosco pelo',
        voltar: 'Voltar para o Início',
        erro: 'Erro ao carregar sua solicitação'
    },
    show: {
        aguardando: 'Orçamento em processamento!',
        atualizar: 'Atualizar',
        orcamento_sucesso: 'Orçamento gerado com Sucesso!',
        funcionalidade_construcao: 'Funcionalidade em Construção'
    }
}
